/**
 * @Description: 文本说明 组件
 * @author Shi_qshan
 * @date 2021/12/14
 */
import React from "react";
import green from "../../image/common/zkTextArea/green.png"
import yellow from "../../image/common/zkTextArea/yellow.png"
import blue from "../../image/common/zkTextArea/blue.png"
import red from "../../image/common/zkTextArea/red.png"

/**
 * @param type: string 类型，可选 green，blue，red，yellow
 * @param value: 文本值
 * @param style: object 类型,自定义 style
 * @param className: css props,自定义的 className
 * @param width: 组件的宽度，默认100%，如果需要固定宽度，可以自定义
 * @param 防止组件使用错误，以上属性 除了style和className外，其他内部都给了默认值，请按需传参
 */
const ZkTextArea = (props) => {
    const {type: pType, value: pValue, width: pWidth, style: pStyle, className: pClassName} = props
    const style = {
        background: '',
        border: '',
        width: pWidth,
        ...pStyle
    }
    const img = {
        img: ''
    }
    if (pType == 'green') {
        style.background = '#F6FFEE'
        style.border = '1px solid #B7EB8F'
        img.img = green
    }else if (pType == 'yellow') {
        style.background = '#FEFBE6'
        style.border = '1px solid #FFE58F'
        img.img = yellow
    }
    else if (pType == 'red') {
        style.background = '#FFF1F0'
        style.border = '1px solid #FFA39E'
        img.img = red
    }
    else if (pType == 'blue') {
        style.background = '#EDF4FF'
        style.border = '1px solid #D1E3FF'
        img.img = blue
    }
    else{
        style.background = '#EDF4FF'
        style.border = '1px solid #D1E3FF'
        img.img = blue
    }
    return (
        <div className={`zkText_max ${pClassName}`} style={style}>
            <img src={img.img} className={'zkText_img'}/>
            <div className={'zkText_value'}>{pValue || '组件未传递value值'}</div>
        </div>
    )
}

export default ZkTextArea